export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'A form type with the same name already exists in this establishment'
    }
  }
}
